<template>
  <Sidebar v-model:visible="visible" position="right" @hide="onHide" :pt="{
    sidebar: {
      class: ['max-w-7xl'],
    }
	}">
    <div v-if="log" class="flex flex-col space-y-8">
      <div class="flex flex-col space-y-8 sticky top-0 bg-white">
        <div>
          <div class="flex items-center space-x-3">
            <h3 class="text-xl font-bold text-gray-900 sm:text-2xl">{{ device.serial_number }}</h3>
          </div>

          <p class="text-sm text-gray-500">{{ log.description }}</p>
        </div>

        <div>
          <DescriptionList :title="$t('slide_overs.device_config_update_log_slide_over.information')" class="mt-2">
            <DescriptionListItem :term="$t('slide_overs.device_config_update_log_slide_over.created_by')"
                                 :details="log.causer?.name"/>
            <DescriptionListItem :term="$t('slide_overs.device_config_update_log_slide_over.created_at')"
                                 :details="log.causer ? $dateService(log.created_at).format('MMM DD, YYYY') : undefined"/>
          </DescriptionList>
        </div>

        <FormGroup class="-mx-6 px-6 pb-4 border-b border-slate-200">
          <InputText type="search" v-model="search"
                     :placeholder="$t('slide_overs.device_config_update_log_slide_over.search_config_keys')"/>
        </FormGroup>
      </div>

      <template v-for="(section, key) in configDetails">
        <DescriptionList v-if="section.items.length" :title="section.value" class="mt-2">
          <DescriptionListItem v-for="(item, key) in section.items" :term="item.title" :details="item.value"/>
        </DescriptionList>
      </template>

    </div>
  </Sidebar>
</template>

<script>
import DescriptionList from "@/Components/DescriptionList.vue";
import DescriptionListItem from "@/Components/DescriptionListItem.vue";
import FormGroup from "@/Components/FormGroup.vue";

export default {
  name: "DeviceConfigUpdateLogSlideOver",
  components: {FormGroup, DescriptionListItem, DescriptionList},
  data() {
    return {
      visible: false,
      device: undefined,
      log: undefined,
      search: undefined,
    }
  },
  computed: {
    configDetails() {
      let config = {};

      /**
       * Some gross formatting to turn the following event log data into a nested array:
       * {
       *   "Section1": "[DIAG++ VERSION]",
       *   "Section1:Version": "3.0.1"
       * }
       * into
       * {
       *   title: "Section1",
       *   value: "DIAG++ VERSION",
       *   items: [
       *     {
       *       title: "Version",
       *       value: "3.0.1",
       *     }
       *   ]
       * }
       */
      Object.entries(this.log.properties.config).sort().forEach(([key, value]) => {
        let keys = key.split(':', 2);

        if (!config.hasOwnProperty(keys[0])) {
          config[keys[0]] = {
            title: key,
            value: value?.replace('[', '').replace(']', '') ?? 'N/A',
            items: [],
          }
        }

        if (keys[1]) {
          const itemMatches = !this.search?.length || keys[1].toLowerCase().includes(this.search.toLowerCase());
          const sectionMatches = !this.search?.length || config[keys[0]].value.toLowerCase().includes(this.search.toLowerCase());

          if (itemMatches || sectionMatches) {
            config[keys[0]].items.push({
              title: keys[1],
              value: value
            })
          }
        }
      });

      return config;
    }
  },
  methods: {
    async showDeviceConfigUpdateLog(device, log) {
      if (!log || !device)
        return;

      this.device = device;
      this.log = log;

      this.visible = true;
    },
    onHide() {
      this.device = undefined;
      this.log = undefined;
    },
  },
}
</script>